/**
 * demo-ask: the demo's two asks once it has made something of its own
 * (application/services/demo_email_ask.py says when each applies).
 *
 * On the demo banner's capture bar it raises the bar as a sheet asking to
 * keep what was made, and lowers it on Not now or on submit; the form and its
 * fetch stay demo-capture.js. With a modal value it opens that modal on
 * connect: name-the-business, after the demo gave its email.
 *
 * Each ask shows once per tab, and that is decided here, not by the server:
 * the service worker renders pages nobody sees (prefetch, saved copies), so a
 * render cannot tell whether its ask reached the screen.
 */
import { Controller } from "@hotwired/stimulus";

const RAISED = "demo-capture-top--ask";

export default class extends Controller {
    static values = { modal: String };

    connect() {
        const key = `demo-ask-shown:${this.modalValue || "email"}`;
        // Never over the walkthrough's card; the ask waits for a later page.
        if (this._seen(key) || document.querySelector("dialog.walkthrough[open]")) return;
        this._remember(key);
        if (this.modalValue) {
            this._openModal(this.modalValue);
            return;
        }
        this.element.classList.add(RAISED);
    }

    dismiss() {
        this.element.classList.remove(RAISED);
    }

    _openModal(id) {
        const el = document.getElementById(id);
        if (el && window.bootstrap) window.bootstrap.Modal.getOrCreateInstance(el).show();
    }

    _seen(key) {
        try {
            return sessionStorage.getItem(key) === "1";
        } catch {
            return false;
        }
    }

    _remember(key) {
        try {
            sessionStorage.setItem(key, "1");
        } catch {
            /* not kept: the ask may show again on the next page */
        }
    }
}
